import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { paginateData, calculateTotalPages } from "../../../assets/js/script";
import TableHeader from "../../Common/TableComponent/TableHeader";
import EntriesDropdown from "../../Common/TableComponent/EntriesDropdown";
import TablesRow from "../../Common/TableComponent/TablesRow";
import { Pagination } from "../../Common/TableComponent/Pagination";
import {
  fetchProductReviews,
  deleteProductReview,
} from "../../../services/productReviewService";
import { Loading } from "../../Common/OtherElements/Loading";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { confirmDelete } from "../../Common/OtherElements/confirmDeleteClone";
import { TableDataStatusError } from "../../Common/OtherElements/TableDataStatusError";
import { handleErrors } from "../../../utils/errorHandler";
import { usePageLevelAccess } from "../../../hooks/usePageLevelAccess";
import ComponentHeader from "../../Common/OtherElements/ComponentHeader";
import ProductReviewToggleSwitch from "./ProductReviewToggleSwitch";
import ProductReviewFeaturedToggleSwitch from "./ProductReviewFeaturedToggleSwitch";

const ViewProductReview = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [manageProductReviews, setManageProductReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageAccessDetails, setPageAccessDetails] = useState([]);
  const PageLevelAccessurl = "product-review";
  const navigate = useNavigate();
  const { pageAccessData } = usePageLevelAccess(PageLevelAccessurl);

  useEffect(() => {
    if (pageAccessData) {
      if (!pageAccessData.viewAccess) {
        navigate("/404-error-page");
      } else {
        setPageAccessDetails(pageAccessData);
      }
    } else {
      console.log("No page access details found");
    }
  }, [pageAccessData, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await fetchProductReviews();
        if (response.isSuccess) {
          setManageProductReviews(response.result);
        }
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredData = manageProductReviews.filter(
    (emailSubscribes) =>
      emailSubscribes.emailId
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      emailSubscribes.productName
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (emailSubscribes.firstName + "" + emailSubscribes.lastName)
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      emailSubscribes.mobileNo
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      String(emailSubscribes.rating)
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  const currentData = paginateData(filteredData, currentPage, entriesPerPage);
  const totalPages = calculateTotalPages(filteredData.length, entriesPerPage);

  const handleEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const handleDelete = async (contactRequestId) => {
    const confirmed = await confirmDelete("product review");
    if (confirmed) {
      try {
        await deleteProductReview(contactRequestId);
        setManageProductReviews((prev) =>
          prev.filter((item) => item.id !== contactRequestId)
        );
        Swal.fire(
          "Deleted!",
          "Product review deleted successfully!",
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };
  const handleStatusChange = (id, newStatus) => {
    setManageProductReviews((prevProperties) =>
      prevProperties.map((property) =>
        property.id === id ? { ...property, status: newStatus } : property
      )
    );
  };
  return (
    <>
      <ToastContainer />
      <ComponentHeader title="View Product Reviews" />
      {pageAccessDetails.viewAccess ? (
        <div className="row">
          <div className="col-xxl-12">
            <div className="card mt-xxl-n5">
              <div className="card-header">
                <h5 className="mb-sm-2 mt-sm-2">Manage Product Reviews</h5>
              </div>
              <div className="card-body manage-amenity-master-card-body">
                <div className="pagination-details-responsive justify-content-between mb-3">
                  <EntriesDropdown
                    entriesPerPage={entriesPerPage}
                    onEntriesChange={handleEntriesChange}
                    options={[10, 25, 50, 100]}
                  />
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control mb-2"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                {loading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-bordered">
                      <TableHeader
                        columns={[
                          "#",
                          "Product Name",
                          "Customer",
                          "Message",
                          "Published?",
                          "Featured?",
                          "Added On",
                          "Action",
                        ]}
                      />
                      <tbody className="manage-property-owner-table-values">
                        {currentData.length === 0 ? (
                          <TableDataStatusError colspan="8" />
                        ) : (
                          currentData.map((item, index) => (
                            <TablesRow
                              key={item.id}
                              rowData={{
                                Id:
                                  (currentPage - 1) * entriesPerPage +
                                  index +
                                  1,
                                productName: item.productName,
                                customer: (
                                  <div className="fs-12">
                                    <span className="text-start d-block mb-2">
                                      <strong>Name:</strong>{" "}
                                      {item.firstName + " " + item.lastName}
                                    </span>
                                    <span className="text-start d-block mb-2">
                                      <strong>Email Id:</strong> {item.emailId}
                                    </span>
                                    <span className="text-start d-block mb-2">
                                      <strong>Mobile No:</strong>{" "}
                                      {item.mobileNo}
                                    </span>
                                    <span className="text-start d-block mb-2">
                                      <strong>Rating:</strong> {item.rating}
                                    </span>
                                  </div>
                                ),
                                message: item.message,
                                publishOrUnPublish: (
                                  <ProductReviewToggleSwitch
                                    propId={item.id}
                                    initialStatus={
                                      item.published === true
                                        ? "Published"
                                        : "UnPublished"
                                    }
                                    onStatusChange={(newStatus) =>
                                      handleStatusChange(item.id, newStatus)
                                    }
                                  />
                                ),
                                featuredOrUnFeatured: (
                                  <ProductReviewFeaturedToggleSwitch
                                    propId={item.id}
                                    initialStatus={
                                      item.featured === true
                                        ? "Featured"
                                        : "UnFeatured"
                                    }
                                    onStatusChange={(newStatus) =>
                                      handleStatusChange(item.id, newStatus)
                                    }
                                  />
                                ),
                                modifiedOn: (
                                  <div>
                                    {new Date(item.modifiedOn)
                                      .toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true,
                                      })
                                      .replace(",", "")}
                                  </div>
                                ),
                              }}
                              columns={[
                                "Id",
                                "productName",
                                "customer",
                                "message",
                                "publishOrUnPublish",
                                "featuredOrUnFeatured",
                                "modifiedOn",
                              ]}
                              hideIcons={false}
                              onDelete={() => handleDelete(item.id)}
                              pageLevelAccessData={pageAccessDetails}
                            />
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalEntries={filteredData.length}
                  entriesPerPage={entriesPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ViewProductReview;
